import React from 'react'
import useFetch from '@e3dc-react/shell/Hooks/useFetch'
import { Routes, useParams, Route } from 'react-router-dom'
import { useActiveInstallation } from 'src/Hooks'
import { useInstallationPageHandler } from 'src/Hooks/use-installation-page-handler'
import { Installation } from 'src/Libs/installations/models'
import { AI360Route } from 'src/Routes/AI360'

/**
 * The main page component for AI360° that handles routing and installation context.
 */
const AI360MainPage: React.FC = () => {
  const { installationId } = useParams<{ installationId: string; storageId: string }>()

  if (!installationId) throw new Error('Installation ID is required')

  useInstallationPageHandler('ai360.header.main-page-title')

  // handle the loading page skeleton later on
  const [installation] = useFetch<Installation>({
    url: `installations/${installationId}`,
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    doNotFetch: !installationId,
    retryOnFailure: false,
  })

  const storageId = installation?.emsMasterDeviceId
  useActiveInstallation(true, installationId, storageId ?? '')

  return (
    <Routes>
      <Route path={`/*`} element={<AI360Route />} />
    </Routes>
  )
}

export default AI360MainPage
